var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('paginated-table', {
    ref: "table",
    attrs: {
      "store": _vm.store,
      "headers": _vm.headers,
      "baseQuery": {
        partnerId: _vm.partnerId
      },
      "controlElements": _vm._controlElements,
      "predefinedFilter": _vm.predefinedFilter,
      "quickFilters": _vm.quickFilters,
      "selectedItems": _vm.selectedItems,
      "showSelect": true,
      "sortBy": "due"
    },
    on: {
      "update:selectedItems": function updateSelectedItems($event) {
        _vm.selectedItems = $event;
      },
      "update:selected-items": function updateSelectedItems($event) {
        _vm.selectedItems = $event;
      },
      "click:row": _vm.setSelectedItem
    },
    scopedSlots: _vm._u([{
      key: "selectActions",
      fn: function fn() {
        return [_c('Can', {
          attrs: {
            "I": _vm.ActionEnum.UPDATE,
            "a": _vm.ResourceEnum.TICKET,
            "field": _vm.partnerId
          }
        }, [_c('div', {
          staticClass: "d-flex align-center"
        }, [_c('span', {
          staticClass: "caption"
        }, [_vm._v(_vm._s(_vm.selectedItems.length) + " " + _vm._s(_vm.$t("selected")))]), _c('v-icon', {
          staticClass: "mx-2",
          attrs: {
            "small": ""
          }
        }, [_vm._v("mdi-arrow-right")]), _c('ticket-acknowledge-dialog', {
          attrs: {
            "value": _vm.selectedItems
          }
        })], 1)])];
      },
      proxy: true
    }, {
      key: "bodyActions",
      fn: function fn() {
        return [!_vm.hideCreateButton ? _c('Can', {
          attrs: {
            "I": _vm.ActionEnum.CREATE,
            "a": _vm.ResourceEnum.TICKET,
            "field": _vm.partnerId
          }
        }, [_c('ticket-create-dialog', {
          attrs: {
            "isDialogActive": _vm.isDialogActive,
            "hideButton": false,
            "partnerId": _vm.partnerId,
            "refs": _vm.refs,
            "tags": _vm.tags
          },
          on: {
            "update:isDialogActive": function updateIsDialogActive($event) {
              _vm.isDialogActive = $event;
            },
            "update:is-dialog-active": function updateIsDialogActive($event) {
              _vm.isDialogActive = $event;
            },
            "created": _vm.setSelectedItem
          }
        })], 1) : _vm._e(), _vm._t("bodyActions")];
      },
      proxy: true
    }, {
      key: "item.vehicleRefs",
      fn: function fn(_ref) {
        var item = _ref.item;
        return _vm._l(item.refs, function (ref) {
          return _c('div', {
            key: item.id + ref.refId + ref.refType
          }, [ref.refType === _vm.BackendResourceEnum.VEHICLE ? _c('refs-list', {
            attrs: {
              "small": true,
              "itemPromise": function itemPromise() {
                return _vm.getVehicleById(ref.refId);
              },
              "refType": _vm.BackendResourceEnum.VEHICLE
            },
            on: {
              "openDetail": function openDetail(vehicle) {
                return vehicle.openDetail(_vm.$router, _vm.VehicleTabs.HOME);
              }
            }
          }) : _vm._e()], 1);
        });
      }
    }, {
      key: "item.state",
      fn: function fn(_ref2) {
        var _vm$ticketStateMap$ge;

        var item = _ref2.item;
        return [_c('tooltip', {
          attrs: {
            "text": _vm.$t('enums.TicketStatusEnum.' + item.state)
          }
        }, [_c('v-avatar', {
          attrs: {
            "color": (_vm$ticketStateMap$ge = _vm.ticketStateMap.get(item.state)) === null || _vm$ticketStateMap$ge === void 0 ? void 0 : _vm$ticketStateMap$ge.color,
            "size": "15px"
          }
        })], 1)];
      }
    }, {
      key: "item.timestamp.created",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_vm._v(" " + _vm._s(_vm._f("simpleDoubleDigitDate")(item.timestamp.created)) + " ")];
      }
    }, {
      key: "item.number",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [_c('strong', [_vm._v("#" + _vm._s(item.number))])];
      }
    }, {
      key: "item.due",
      fn: function fn(_ref5) {
        var item = _ref5.item;
        return [_c('due-date-chip', {
          attrs: {
            "ticket": item
          }
        })];
      }
    }, {
      key: "item.assignees",
      fn: function fn(_ref6) {
        var item = _ref6.item;
        return [_c('assignee-preview', {
          attrs: {
            "value": item.assignees,
            "amount": 1,
            "partnerId": _vm.partnerId,
            "chip": true
          }
        })];
      }
    }, {
      key: "item.title",
      fn: function fn(_ref7) {
        var item = _ref7.item;
        return [item.title ? _c('a', {
          staticClass: "pa-0  text-truncate",
          style: _vm.$vuetify.breakpoint.smAndDown ? 'max-width: 250px;' : 'max-width: 350px;',
          on: {
            "click": function click($event) {
              return _vm.openDetail(item);
            }
          }
        }, [_vm._v(" " + _vm._s(item.title) + " ")]) : _c('div')];
      }
    }, {
      key: "item.tags",
      fn: function fn(_ref8) {
        var item = _ref8.item;
        return [_c('tag-preview', {
          attrs: {
            "value": item.tags,
            "size": "small"
          }
        })];
      }
    }, {
      key: "item.projectId",
      fn: function fn(_ref9) {
        var item = _ref9.item;
        return [_c('span', [_vm._v(_vm._s(_vm.projectName(item.projectId)))])];
      }
    }], null, true)
  }), _vm.selectedItem ? _c('ticket-side-card', {
    attrs: {
      "value": _vm.selectedItem
    },
    on: {
      "close": function close() {
        return _vm.setSelectedItem(null);
      }
    }
  }) : _vm._e(), _vm.isDeleteDialogActive && _vm.selectedItemForDelete ? _c('confirm-action-dialog', {
    attrs: {
      "isDialogActive": _vm.isDeleteDialogActive,
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "title": _vm.$t('partner.PartnerReportDetailChangeProgress.confirmDeleteTitle'),
      "rightColor": 'error',
      "rightLoading": _vm.isDeleteLoading
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isDeleteDialogActive = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isDeleteDialogActive = $event;
      },
      "close": function close($event) {
        _vm.isDeleteDialogActive = false;
      },
      "leftClick": function leftClick($event) {
        _vm.isDeleteDialogActive = false;
      },
      "rightClick": _vm.onDelete
    }
  }, [_c('refs-ticket', {
    attrs: {
      "item": _vm.selectedItemForDelete
    }
  })], 1) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }